module.exports = __webpack_public_path__ + "img/banner2026_en.aaf24849.webp";